import React, {useState} from 'react';
import SelectionsService from '../services/selectionsService';

export const SelectionsContext = React.createContext();

const SelectionsContextProvider = ({ children }) => {
  const [pending, setPending] = useState(false);
  const [addSelectionPending, setAddSelectionPending] = useState(false);
  const [error, setError] = useState(false);
  const [selections, setSelections] = useState([]);
  const [selectionVersion, setSelectionVersion] = useState(null);

  const getSelections = async () => {
    setError(false);
    setPending(true);
    const responseObj = await SelectionsService.getSelections();

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setSelections(responseObj._embedded.selectionLists);
    }

    setPending(false);

    return responseObj;
  };

  const getSelectionVersion = async id => {
    setError(false);
    setPending(true);
    const responseObj = await SelectionsService.getSelectionVersion(id);

    if (responseObj.type === 'Error') {
      setError(true);
    } else {
      setSelectionVersion(responseObj);
    }

    setPending(false);

    return responseObj;
  };

  const addSelection = async formValues => {
    setError(false);
    setAddSelectionPending(true);

    let payload = {...formValues};

    const response = await SelectionsService.addSelectionList(payload);

    if (response !== 200) {
      setError(true);
      setAddSelectionPending(false);
      return response;
    }

    setAddSelectionPending(false);
    return response;
  };

  const updateSelection = async (formValues, id, version) => {
    setError(false);
    setAddSelectionPending(true);

    let payload = {...formValues};

    const response = await SelectionsService.updateSelectionList(payload, id, version);

    if (response !== 200) {
      setError(true);
      setAddSelectionPending(false);
      return response;
    }

    setAddSelectionPending(false);
    return response;
  };

  const deleteSelection = async id => {
    setError(false);
    setAddSelectionPending(true);

    const response = await SelectionsService.deleteSelectionList(id);

    if (response !== 204) {
      setError(true);
      setPending(false);
      return response;
    }

    setAddSelectionPending(false);
    return response;
  };

  return (
    <SelectionsContext.Provider
      value={{
        pending,
        addSelectionPending,
        error,
        selections,
        selectionVersion,
        getSelections,
        getSelectionVersion,
        addSelection,
        updateSelection,
        deleteSelection
      }}
    >
      {children}
    </SelectionsContext.Provider>
  );
};

export default SelectionsContextProvider;
